export const K_USER_STATUS_APPROVED = 'approved';
export const K_USER_STATUS_REJECTED = 'rejected';
export const K_USER_STATUS_PENDING = 'pending';
export const K_USER_STATUS_BANNED = 'banned';

export const K_USER_LEVEL_ANONYMOUS = 0;
export const K_USER_LEVEL_VERIFIED_EMAIL = 1;
export const K_USER_LEVEL_KYC = 2;
export const K_USER_LEVEL_BANK_ACCOUNT = 3;
